import React from "react";
import { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdOutlineRestaurantMenu } from "react-icons/md";

// import images from "../../constants/images";
import "./Navbar.css";

const Navbar = () => {
	const [toggleMenu, setToggleMenu] = useState(false);

	// Sticky
	var prevScrollPos = window.pageYOffset;
	console.log(prevScrollPos + "- 1st psp");

	window.onscroll = function () {
		if (window.scrollY > 200) {
			var curntScrollPos = window.pageYOffset;
			sticky();
		}
		function sticky() {
			if (curntScrollPos > prevScrollPos) {
				document.getElementById("navbar").style.top = "-100px";
			} else {
				document.getElementById("navbar").style.top = "0";
			}
			prevScrollPos = curntScrollPos;
		}
	};

	return (
		<div className="app__navbar" id="navbar">
			<div className="app__navbar-logo">
				<a href="#">
					<img
						className="app__navbar-logo_img"
						src="./favicon.png"
						alt="Logo"
					/>
				</a>

				<a href="#">
					<h1 id="h1h">MARY MATHA CATHERING SERVICE</h1>
				</a>
			</div>
			<div className="app__navabr-logo_name-smallscreen">
				<a href="#">
					<h1 id="h2h">M M C</h1>
				</a>
			</div>

			<ul className="app__navbar-links">
				<li className="p__opensans">
					<a href="#home">Home</a>
				</li>
				<li className="p__opensans">
					<a href="#about">About Us</a>
				</li>
				<li className="p__opensans">
					<a href="#menu">Menu</a>
				</li>
				<li className="p__opensans">
					<a href="#gallery">Gallery</a>
				</li>
				<li className="p__opensans">
					<a href="#contact">Contact Us</a>
				</li>
			</ul>

			<div className="app__navbar-smallscreen">
				<GiHamburgerMenu
					color={"#bebebe"}
					fontSize={27}
					onClick={() => {
						setToggleMenu(true);
					}}
				/>

				{toggleMenu && (
					<div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
						<MdOutlineRestaurantMenu
							className={"overlay__close"}
							fontSize={27}
							onClick={() => {
								setToggleMenu(false);
							}}
						/>
						<ul className="app__navbar-smallscreen_links">
							<li className="p__opensans">
								<a
									href="#home"
									onClick={() => {
										setToggleMenu(false);
										console.log("Home presssed", toggleMenu);
									}}
								>
									Home
								</a>
							</li>
							<li className="p__opensans">
								<a
									href="#about"
									onClick={() => {
										setToggleMenu(false);
										console.log("About presssed", toggleMenu);
									}}
								>
									About Us
								</a>
							</li>
							<li className="p__opensans">
								<a
									href="#menu"
									onClick={() => {
										setToggleMenu(false);
										console.log("Menu presssed", toggleMenu);
									}}
								>
									Menu
								</a>
							</li>
							<li className="p__opensans">
								<a
									href="#gallery"
									onClick={() => {
										setToggleMenu(false);
										console.log("Gallery presssed", toggleMenu);
									}}
								>
									Gallery
								</a>
							</li>
							<li className="p__opensans">
								<a
									href="#contact"
									onClick={() => {
										setToggleMenu(false);
										console.log("Contact presssed", toggleMenu);
									}}
								>
									Contact Us
								</a>
							</li>
						</ul>
					</div>
				)}
			</div>
		</div>
	);
};

export default Navbar;
